import React from 'react';

import { Icon as AnimationIcon } from '../assets/animation.svg';

export const GraphQLAnimation = () => {
  if (!AnimationIcon) {
    return (
      <div className="flex shrink-0 items-center justify-center">
        Animation could not be loaded
      </div>
    );
  }

  return (
    <div className="flex size-full justify-center md:justify-start">
      <AnimationIcon
        className="chromatic-ignore"
        width={88}
        height={88}
        style={{
          minWidth: '88px',
          minHeight: '88px',
          maxWidth: '88px',
          maxHeight: '88px',
          animationDelay: '0s',
          transitionDelay: '0s',
        }}
      />
    </div>
  );
};
